import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-virtual-ring"
    exact
    path="/business/products/ar-virtual-ring"
    component={AsyncPage}
  />,
];
